import { FC, SVGProps } from 'react'

export const ArrowIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5011 7.18006C28.1032 7.78212 28.1032 8.75825 27.5011 9.36031L16.8615 19.9998L27.5011 30.639C28.1032 31.2411 28.1032 32.2172 27.5011 32.8193C26.899 33.4213 25.9229 33.4213 25.3208 32.8193L12.501 19.9998L25.3208 7.18006C25.9229 6.578 26.899 6.578 27.5011 7.18006Z"
        fill="#14151A"
      />
    </svg>
  )
}
